<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Canal">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="_id" placeholder="_ID" v-model="form._id" disabled/>
                  <label for="_id">_ID</label>
                </div>
              </b-col> -->
              <b-col md="12"></b-col>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="code" placeholder="code" v-model="form.code" :disabled="isUpdate"/>
                  <label for="code">Code</label>
                </div>
              </b-col> -->
              <b-col md="4">
                <div class="form-label-group">
                  <b-form-input id="name" placeholder="Nome" v-model="form.name" />
                  <label for="name">Nome</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="4">
                <div class="form-label-group">
                  <!-- <label for="code-list">Tipo</label> -->
                  <b-form-group label="Tipo" label-for="code-list">
                  <v-select
                    id="code-list"
                    v-model="form.code"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="codeList"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              
              <template v-if="isMDTP || isApp || isPlatform || isPublicArea || isWordpress">
                <b-col class="mb-2" md="12"><hr /></b-col>
                <b-col md="12" v-if="isMDTP"><h3>Configuração do Legado</h3></b-col>
                <b-col md="12" v-if="isApp"><h3>Configuração do Aplicativo</h3></b-col>
                <b-col md="12" v-if="isPlatform || isPublicArea"><h3>Configuração da Plataforma</h3></b-col>
                <b-col md="12" v-if="isWordpress"><h3>Configuração do Wordpress</h3></b-col>
                <b-col md="12"></b-col>
                <b-col md="4">
                  <div class="form-label-group">
                    <label for="origin-list">Origem</label>
                    <b-form-group label="Origem" label-for="origin-list">
                    <v-select
                      id="origin-list"
                      v-model="form.origin"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="origins"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                  </div>
                </b-col>
                <b-col md="12"></b-col>
                <template v-if="isApp || isPlatform"> 
                  <b-col class="mb-2" md="12"><hr /></b-col>
                  <b-col md="12"><h3>Configuração de envio de push</h3></b-col>
                  <b-col md="4">
                    <div class="form-label-group" style="margin-top: 10px">
                      <b-form-input id="push_app_id" placeholder="APP ID" v-model="form.push_app_id" />
                      <label for="push_app_id">APP ID</label>
                    </div>
                  </b-col>
                  <b-col md="8">
                    <div class="form-label-group">
                      <b-form-input id="push_api_token" placeholder="API Token" v-model="form.push_api_token" />
                      <label for="push_api_token">API Token</label>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <div class="form-label-group">
                      <label for="category-list">Tipo de serviço</label>
                      <b-form-group label="Categorias" label-for="category-list">
                      <v-select
                        id="category-list"
                        v-model="form.push_service_type"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="name"
                        class="subject-select-field"
                        :options="pushServiceType"
                        :reduce="option => option.id"
                      >
                        <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </b-col>
                </template>
                <template v-if="isWordpress">
                  <b-col md="12">
                    <div class="form-label-group">
                      <label for="category-list">Categorias</label>
                      <b-form-group label="Categorias" label-for="category-list">
                      <v-select
                        id="category-list"
                        v-model="form.category"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        label="name"
                        class="subject-select-field"
                        :options="categories"
                      >
                        <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                      </v-select>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-label-group" style="margin-top: 10px">
                    <b-form-input id="channel-redis" placeholder="Canal Redis" v-model="form.channel_redis" />
                    <label for="channel-redis">Canal Redis</label>
                  </div>
                </b-col>
                </template>
                
              </template>

              <template v-if="isPublicArea">
                <b-col class="mb-2" md="12"><hr /></b-col>
                <b-col md="12"><h3>Configuração da área publica</h3></b-col>
                <b-col md="4">
                  <div class="form-label-group" v-if="isPublicArea">
                    <label for="origin-list">Assunto MDTP area pública</label>
                    <b-form-group label="Assunto" label-for="origin-list">
                    <v-select
                      id="origin-list"
                      v-model="form.subjects"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="subjects"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                  </div>
                </b-col>
              </template>


              <template v-if="isTwitter">
                <b-col class="mb-2" md="12"><hr /></b-col>
                <b-col md="12"><h3>Twitter</h3></b-col>
                <b-col md="12"></b-col>
                <b-col md="4">
                  <div class="form-label-group" style="margin-top: 10px">
                    <b-form-input id="twitter_api_key" placeholder="API Key" v-model="form.twitter_api_key" />
                    <label for="twitter_api_key">API Key</label>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-label-group">
                    <b-form-input id="twitter_api_key_secret" placeholder="API Key Secret" v-model="form.twitter_api_key_secret" />
                    <label for="twitter_api_key_secret">API Key Secret</label>
                  </div>
                </b-col>
                <b-col md="4"></b-col>
                <b-col md="4">
                  <div class="form-label-group">
                    <b-form-input id="twitter_access_token_key" placeholder="Access Token Key" v-model="form.twitter_access_token_key" />
                    <label for="twitter_access_token_key">Access Token Key</label>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-label-group">
                    <b-form-input id="twitter_access_token_secret" placeholder="Access Token Secret" v-model="form.twitter_access_token_secret" />
                    <label for="twitter_access_token_secret">Access Token Secret</label>
                  </div>
                </b-col>
                <!-- <b-col md="4">
                  <div class="form-label-group">
                    <b-form-input id="twitter_bearer_token" placeholder="Bearer Token" v-model="form.twitter_bearer_token" />
                    <label for="twitter_bearer_token">Bearer Token</label>
                  </div>
                </b-col> -->
              </template>
              <template v-if="isTelegram">
                <b-col class="mb-2" md="12"><hr /></b-col>
                <b-col md="12"><h3>Telegram</h3></b-col>
                <b-col md="12"></b-col>
                <b-col md="4">
                  <div class="form-label-group" style="margin-top: 10px">
                    <b-form-input id="telegram_chat_id" placeholder="Chat ID" v-model="form.telegram_chat_id" />
                    <label for="telegram_chat_id">Chat ID</label>
                  </div>
                </b-col>
                <b-col md="4">
                  <div class="form-label-group">
                    <b-form-input id="telegram_token" placeholder="Token" v-model="form.telegram_token" />
                    <label for="telegram_token">Token</label>
                  </div>
                </b-col>
              </template>

              
              <b-col md="12"></b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import channelService from "@/providers/channelService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import AppConstants from '@/appConstants';
import vSelect from "vue-select";

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      categories: [],
      subjects: [],
      pushServiceType: [],
      form: {
        _id: "",
        code: "",
        name: "",
        active: true,
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",

        telegram_chat_id: '',
        telegram_token: '',
        
        twitter_api_key: '',
        twitter_api_key_secret: '',
        twitter_access_token_key: '',
        twitter_access_token_secret: '',
        twitter_bearer_token: '',

        push_app_id: '',
        push_api_token: '',
        push_service_type: '',

        origin: "",
        category: "",
        subjects: "",
        channel_redis: ""
      },
      codeList: []
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Canal');
    this.loadData();
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
      this.getChannelDetail();
    }

  },
  watch: {
    "form.origin"(val) {
      if (val) {
        if (this.isWordpress) {
          this.loadCategory();
        }
      }
    },
    "form.category"(val) {
      if (val) {
        if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
          const cat = JSON.parse(JSON.stringify(this.categories));
          cat.shift();
          this.form.category = cat;
        }
      }
    },
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo Canal');
      }
    }
  },
  computed: {
    isMDTP() {
      return this.form.code == AppConstants.CHANNELS.LEGACY;
    },
    isWordpress() {
      return this.form.code == AppConstants.CHANNELS.WORDPRESS;
    },
    isApp() {
      return this.form.code == AppConstants.CHANNELS.APP;
    },
    isTelegram() {
      return this.form.code == AppConstants.CHANNELS.TELEGRAM;
    },
    isTwitter() {
      return this.form.code == AppConstants.CHANNELS.TWITTER;
    },
    isPlatform() {
      return this.form.code == AppConstants.CHANNELS.PLATFORM;
    },
    isPublicArea() {
      return this.form.code == AppConstants.CHANNELS.PUBLIC_AREA;
    },
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_CHANNEL);
    },
    onSubmit() {
      const form = JSON.parse(JSON.stringify(this.form));
      form.code = form.code.id
      channelService
        .registerChannel(form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getChannelDetail() {
      const params = new URLSearchParams();
      channelService
        .getChannelDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.code = this.codeList.find(item => item.id == res.code);
          this.form.name = res.name;
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;

          this.form.telegram_chat_id = res.telegram_chat_id;
          this.form.telegram_token = res.telegram_token;
          this.form.twitter_api_key = res.twitter_api_key;
          this.form.twitter_api_key_secret = res.twitter_api_key_secret;
          this.form.twitter_access_token_key = res.twitter_access_token_key;
          this.form.twitter_access_token_secret = res.twitter_access_token_secret;
          // this.form.twitter_bearer_token = res.twitter_bearer_token;
          this.form.origin = res.origin;
          this.form.category = res.category;
          this.form.subjects = res.subjects;
          this.form.channel_redis = res.channel_redis;
          this.form.push_app_id = res.push_app_id;
          this.form.push_api_token = res.push_api_token;
          this.form.push_service_type = res.push_service_type;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getAllSubjects(new URLSearchParams()),
        dropdownService.getPushServiceType(new URLSearchParams())
      ])
        .then((res) => {
          this.origins = res[0];
          this.subjects = res[1];
          this.pushServiceType = res[2];
          Object.keys(AppConstants.CHANNELS).forEach(item => {
            this.codeList.push(AppConstants.CHANNELS[item]);
          });
          if (this.isUpdate) {
            this.getChannelDetail();
          }
        })
        .catch((err) => console.log(err));
    },
    loadCategory() {
      if (this.form.origin) {
        const params = new URLSearchParams();
        params.append('origins', this.form.origin.id)
        dropdownService
          .getCategory(params)
          .then((res) => {
            this.categories = res;
            this.categories.unshift(AppConstants.DROPDOWN_ALL_OPTION);
          })
          .catch((err) => console.log(err));
      }
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect,
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>